import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { clearBill } from "../utils/bill";
import FullPageSpinner from "../components/FullPageSpinner";
import { sendRequest } from "../utils/api";
import { useToast } from "../context/ToastContext";
import { getCurrentHostInfo, isEmptyObject } from "../utils/helper-function";

export default function PaymentProcessing() {
  const [params] = useSearchParams();
  const [loading, setLoading] = useState(true);

  const { showToast } = useToast();

  useEffect(() => {
    let attempts = 0;
    const MAX_RETRIES = 3;

    const processPayment = async () => {
      try {
        const ref = params.get("reference");
        const billId = params.get("billId");
        const type = params.get("type");

        const allowedPayFor = ["services", "extendBooking", "onlineBooking"];

        if (!ref || !billId) {
          showToast("Invalid payment data", { type: "error" });
          return;
        }

        if (!allowedPayFor.includes(type ?? "")) {
          showToast("Invalid payment type", { type: "error" });
          return;
        }

        // 🔁 Retry logic for verification
        let response;
        while (attempts < MAX_RETRIES) {
          try {
            response = await sendRequest("GET", `/payment/verify/${ref}`);
            break; // success → exit loop
          } catch (err) {
            attempts++;
            if (attempts >= MAX_RETRIES) throw err;

            await new Promise(res => setTimeout(res, 1000)); // wait 1s
          }
        }

        if (response?.success) {

          const dataStr = localStorage.getItem("data");
          const data = JSON.parse(dataStr ?? "{}");

          if (isEmptyObject(data) && type != "services") {
            throw new Error("Booking Data Not Found.");
          }

          if (type === "services") {
            await clearBill("bill", billId, true);

            setTimeout(() => {
              window.location.href = "/guests/billing";
            }, 1500);

          } else if (type === "extendBooking") {

            await sendRequest(
              "POST",
              `/bookings/${billId}/extend`,
              data
            );

            window.location.href = "/guests/billing";
          } else if (type === "onlineBooking") {

            const { subdomain } = getCurrentHostInfo();

            // Send booking request
            const response = await sendRequest(
              "POST", `/hotels/${subdomain}/book-room`, data
            );

            const payload = response.data;

            localStorage.setItem("bookingPayload", JSON.stringify(payload))
            window.location.href = "/guests/booking/success";
          }

        } else {
          showToast("Payment verification failed", { type: "error" });
        }

      } catch (error: any) {
        console.error("FULL ERROR:", error);
        // console.error("BACKEND ERROR:", error?.response?.data);
        showToast("Error processing payment. Please try again.", { type: "error" });
      } finally {
        localStorage.removeItem("data");
        setLoading(false);
      }
    };

    processPayment();
  }, []);

  return <FullPageSpinner show={loading} />;
}